import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: schools.FieldOption (the same fields as people.FieldOption).
export default class ValueListItem extends Fragment {
  declare [Type]: 'dynamic-field/value-list-item';

  // value is what actually gets stored in the database if this option is selected.
  @attr('string', { defaultValue: '' })
  declare value: string;

  // label is a human-friendly label for this option.
  @attr('string', { defaultValue: '' })
  declare label: string;

  // valueInt is used for storing numeric values in the database
  @attr('number', { defaultValue: 0 })
  declare valueInt: number;
}
